import { render } from "./RouteLogout.vue?vue&type=template&id=470275fb"
import script from "./RouteLogout.vue?vue&type=script&lang=js"
export * from "./RouteLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__